import { Component, OnInit } from '@angular/core';
import { TicketComponent } from '../../ticket/ticket.component';
import { ITicketInfo } from 'src/app/models/ticket/ticketInfo.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ScannerType, TypeOfPlaceBetTicket } from 'src/app/models/enums';
declare var $: any;

@Component({
  selector: 'app-ticket-mobile',
  templateUrl: './ticket-mobile.component.html',
  styleUrls: ['./ticket-mobile.component.less']
})
export class TicketMobileComponent extends TicketComponent implements OnInit{
 // showTicketDetails = false;
  mobileConentWrap: any;
  // selectedBetTypeIndex = 1;
  // ticketInfo: ITicketInfo;
  constantValues = ConstantValues;
  isScanCodeActive = false;


  // openQrScaner = false;

  // qrResultString: string;

  // ngOnInit(){
  //    this.placeBetType=TypeOfPlaceBetTicket.Standard
  // }
  ticketPayInRestriction(){
    const ticketPayin = document.getElementById('totalStakeInput');
    ticketPayin.addEventListener('input', (e) => {
      const target = e.currentTarget as HTMLInputElement;
      if (+target.value > ConstantValues.MAX_STAKE) {
        target.value = ConstantValues.MAX_STAKE.toString();
      }
    });
  }

  openTicketDetails() {
    if (this.showTicketDetails) {
      this.onTiketChange(this.TicketTabENUM.Ticket);
      this.stopScaning();
    }else{
      this.userService.getNewBalancesFromServer();
    }
    this.showTicketDetails = !this.showTicketDetails;
    setTimeout(() => {
      this.ticketPayInRestriction();

    }, 200);

    if ($('#ticketWrap .bet-type-name').length > 0 && this.showTicketDetails) {
      $('#ticketWrap .bet-type-name').animate({ scrollLeft: 60}, 600);
      setTimeout(() => {
        $('#ticketWrap .bet-type-name').animate({ scrollLeft: 0}, 600);
      }, 600);
    }
    // this.mobileConentWrap = document.getElementsByClassName('mobile-content-wrap')[0];
    // this.mobileConentWrap.classList.toggle('blur');
  }

  // changeTypeOfPlaceBet(event:number){
  //   this.placeBetType=event;
  // }

  scanTicketCompleted(code: string) {
    this.isScanCodeActive = false;
    let ticketCode = '';
    if (isNaN(+code)) {
      const index = code.indexOf('ticket=');
      if (index > -1) {
        ticketCode = code.slice(index + 7);
      }
    } else {
      ticketCode = code;
    }
    if (isNaN(+ticketCode)) {
      this.checkTicketId = '';
      this.checkTicketPin = '';
    } else {
      this.checkTicketPin = ticketCode.slice(-1 * ConstantValues.TICKET_PIN_SIZE);
      this.checkTicketId = ticketCode.slice(0, -1 * ConstantValues.TICKET_PIN_SIZE).replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
    }
    this.checkTicket();
  }

  startScanning(): void {
    // this.openQrScaner = true;
    this.isScanCodeActive = true;
    this.searchMessage = null;
  }


  stopScaning(): void {
    this.isScanCodeActive = false;
    // this.openQrScaner = false;
  }

  get displayFormat(): string {
    return ConstantValues.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE;
  }
}

